/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result of listing distinct attribute keys
 */
export type ListAttributeKeysResult = {
  /**
   * Distinct attribute keys. User attributes are prefixed with @
   */
  keys: Array<string>;
};

/** @internal */
export const ListAttributeKeysResult$inboundSchema: z.ZodMiniType<
  ListAttributeKeysResult,
  unknown
> = z.object({
  keys: z.array(z.string()),
});

export function listAttributeKeysResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAttributeKeysResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAttributeKeysResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAttributeKeysResult' from JSON`,
  );
}
